import CancelIcon from '@mui/icons-material/Cancel';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import photo from '../../../../../../assets/images/homeImage.png';
import Player from '../../../../../Player/Player';
import styles from './contentMobile.module.scss';
import { useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import colors from '../../../../../../utils/colors';
import CircularProgressWithLabel from '../../../../../CreateVideo/CircularProgressWithLabel';

const mapStateToProps = (state) => {
    return {
        upload: state.common.upload
    };
};

const ContentMobile = (props) => {
    const { t } = useTranslation();
    const uniqueHash = useMemo(() => uuidv4(), []);
    const trailerInputRef = useRef(null);
    const upload = props.upload.find((x) => x.jobId === props.jobId);
    const [isPortrait, setIsPortrait] = useState(false);
    const fileInputRef = useRef(null);

    return (
        <Box className={styles.thumbnailAndTrailer}>
            <Box>
                {props.showLoader ? (
                    <Box
                        sx={{
                            marginBottom: '1rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            minHeight: '225px'
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                            <CircularProgress sx={{ color: colors.primary }} />
                            <Typography>The new trailer is converting</Typography>
                        </Box>
                    </Box>
                ) : (
                    <>
                        {props.event.trailerUrl ? (
                            <Box
                                sx={{
                                    marginBottom: '1rem'
                                }}>
                                <Player
                                    style={{ borderRadius: '12px' }}
                                    flag={true}
                                    uniqueHash={uniqueHash}
                                    streamSource={props.event.trailerUrl}
                                    muted={false}
                                    sound={true}
                                    autoplay={false}
                                    event={props.event}
                                    setIsPortrait={setIsPortrait}
                                />
                                <Box className={styles.boxText}>
                                    <Typography fontSize={'14px'}>{t('Trailer')}</Typography>
                                    {upload?.trailer_show ? (
                                        <Box>
                                            <CircularProgressWithLabel
                                                size={30}
                                                color={colors.primary}
                                                showValue={false}
                                                value={upload.trailer_progress}
                                            />
                                        </Box>
                                    ) : (
                                        <Box
                                            className={styles.boxTextBox}
                                            onClick={() =>
                                                trailerInputRef.current &&
                                                trailerInputRef.current.click()
                                            }>
                                            {t('UploadNew')}
                                            <input
                                                type="file"
                                                id="uploadTrailer"
                                                accept="video/*"
                                                onChange={(e) =>
                                                    props.handleVideoUpload(e, 'trailer')
                                                }
                                                style={{ display: 'none' }}
                                                ref={trailerInputRef}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        ) : (
                            <Box sx={{ marginBottom: '1rem' }}>
                                <Box
                                    style={{
                                        position: 'relative',
                                        width: '100%',
                                        border: props.fileUploadError
                                            ? '1px solid red'
                                            : '1px solid white',
                                        borderRadius: '9px',
                                        height: '100%',
                                        paddingTop: !props.trailerFile ? '56.25%' : ''
                                    }}>
                                    {props.trailerFile ? (
                                        <>
                                            <img
                                                style={{
                                                    borderRadius: '14px',
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    maxHeight: '225px'
                                                }}
                                                src={photo}
                                                alt="photo"
                                            />
                                            {upload?.trailer_show && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        borderRadius: '14px',
                                                        width: '100%',
                                                        height: '100%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        zIndex: 999
                                                    }}>
                                                    <CircularProgressWithLabel
                                                        size={30}
                                                        color={colors.primary}
                                                        showValue={false}
                                                        value={upload.trailer_progress}
                                                    />
                                                </Box>
                                            )}
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    props.deleteTrailer();
                                                }}
                                                sx={{
                                                    background: 'white',
                                                    padding: '0px',
                                                    width: '20px',
                                                    height: '20px',
                                                    position: 'absolute',
                                                    top: '5px',
                                                    right: '5px',
                                                    '&:active, &:focus, &:hover': {
                                                        background: 'white'
                                                    }
                                                }}>
                                                <CancelIcon
                                                    sx={{ width: '20px', height: '20px' }}
                                                    color={colors.primaryDarkGray}
                                                />
                                            </IconButton>
                                        </>
                                    ) : (
                                        <Box
                                            onClick={() =>
                                                trailerInputRef.current &&
                                                trailerInputRef.current.click()
                                            }
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '100%',
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0
                                            }}>
                                            <VideoCallIcon />
                                            <Typography fontSize={'10px'}>
                                                {t('AddTrailer')}
                                            </Typography>
                                        </Box>
                                    )}
                                    {!upload?.trailer_show && (
                                        <Box>
                                            <input
                                                type="file"
                                                id="uploadTrailer"
                                                accept="video/*"
                                                onChange={(e) =>
                                                    props.handleVideoUpload(e, 'trailer')
                                                }
                                                style={{ display: 'none' }}
                                                ref={trailerInputRef}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                {props.fileUploadError && (
                                    <Typography sx={{ marginTop: '1rem', color: 'red' }}>
                                        {props.fileUploadError}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </>
                )}
                <Box>
                    {props.thumbnail && (
                        <Box>
                            <Player
                                key={props.imagePreview ?? props.thumbnail}
                                style={{ borderRadius: '12px' }}
                                uniqueHash={uniqueHash}
                                streamSource={props.event.live_stream_url}
                                muted={false}
                                sound={true}
                                autoplay={false}
                                event={props.event}
                                setIsPortrait={setIsPortrait}
                                thumbnail={props.imagePreview ?? props.thumbnail}
                            />
                        </Box>
                    )}
                    <Box className={styles.boxText}>
                        <Typography fontSize={'14px'}>{t('Thumbnail')}</Typography>
                        <Box
                            className={styles.boxTextBox}
                            onClick={() => {
                                if (fileInputRef.current) {
                                    fileInputRef.current.click();
                                }
                            }}>
                            {t('UploadNew')}
                            <input
                                type="file"
                                id="thumbnailUpload"
                                key={props.imagePreview || 'default'}
                                style={{ display: 'none' }}
                                ref={fileInputRef}
                                onChange={props.handleImageChange}
                                accept="image/*"
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default connect(mapStateToProps, null)(ContentMobile);
